/**
 * Keeps one point per calendar day: the last one, which reflects every task resolved that day.
 * Points must be sorted by date.
 */
export function onePointPerDay(points) {
  return points.filter(
    (point, index) =>
      points[index + 1]?.date.toDateString() !== point.date.toDateString()
  );
}
